import React, { useState, useRef, useEffect } from "react";
import { Badge, FileInput, Label, Spinner } from "flowbite-react";
import { IoIosCamera } from "react-icons/io";
import { IoCloseCircle } from "react-icons/io5";

const PhotoUpload = ({
  tag,
  onUpload,
  onDelete,
  images,
  searchOptionalTag,
}) => {
  const [preview, setPreview] = useState(null);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPreview(null);
    if (images?.length > 0) {
      let img = images?.find((img) => img.SurveyTagId == tag.id);
      if (img) {
        setPreview(img.imgURL);
      }
    }
  }, [images, searchOptionalTag]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoading(true);
      try {
        const url = await onUpload(file);
        setPreview(url);
      } catch (error) {
        console.error("Erro ao fazer upload:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleRemove = async (tag) => {
    setLoading(true);
    setPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (onUpload) {
      onUpload(null);
    }

    await onDelete(tag);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="flex w-full flex-col items-center justify-center relative">
      <Label
        htmlFor={`dropzone-file-${tag.id}`}
        className="relative flex h-40 md:h-52 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border border-gray-300 bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:hover:border-gray-500 dark:hover:bg-gray-600 overflow-hidden"
      >
        <div
          className="absolute bottom-0 left-0 right-0 text-white text-center py-1 text-xs md:text-sm flex items-center min-h-12 justify-center capitalize px-1"
          style={{ background: "rgba(0,0,0,0.6)", zIndex: "1" }}
        >
          {tag?.name?.toLowerCase()}
        </div>
        <div className="flex flex-col items-center justify-center pb-6 pt-5 px-2">
          {preview ? (
            <div className="absolute top-0 bottom-0 right-0 left-0 z-1 h-full w-full">
              <img
                src={`${preview}?t=${Date.now()}`}
                alt="Preview"
                className="h-full w-full w-auto rounded-lg object-cover"
              />
            </div>
          ) : (
            <>
              <IoIosCamera fontSize={40} />
            </>
          )}
        </div>
        <FileInput
          id={`dropzone-file-${tag.id}`}
          ref={fileInputRef}
          className="hidden"
          onChange={handleFileChange}
          accept="image/*"
          name={tag.name}
          capture="environment"
        />
        {loading && (
          <div className="absolute bg-white opacity-70 top-0 bottom-0 left-0 right-0">
            <Spinner
              size="lg"
              color="success"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)",
              }}
            />
          </div>
        )}
      </Label>
      {preview && (
        <button
          onClick={() => handleRemove(tag)}
          type="button" // Garante que o botão não submete formulários
          className="absolute -top-3 -right-2 z-2"
        >
          <IoCloseCircle fontSize={35} color="red" />
        </button>
      )}
    </div>
  );
};

export default PhotoUpload;
